import axios from 'axios';
import {
  IAddressSuggestionCollection,
  IAddressSuggestionsParams,
  IAddress,
  ICreateAddressPayload,
  IAddressListParams,
  IAddressCollection,
  IUpdateAddressPayload,
  IDeleteAddressPayload,
  IUpdateBySellerAddressPayload,
  IAddAddressSubdivisionPayload,
  IRemoveAddressSubdivisionPayload,
} from 'entities/Address/Address.models';

const basePath = 'address';

export const addressesTransport = {
  get: (params: IAddressListParams): Promise<IAddressCollection> => axios.get(`${basePath}`, { params }),
  create: (payload: ICreateAddressPayload): Promise<IAddress> => axios.post(`${basePath}`, payload),
  update: (payload: IUpdateAddressPayload): Promise<IAddress> => axios.patch(`${basePath}`, payload),
  delete: (payload: IDeleteAddressPayload): Promise<IAddress> => axios.delete(`${basePath}`, { data: payload }),
  updateBySeller: (payload: IUpdateBySellerAddressPayload): Promise<IAddress> => axios.patch(`${basePath}/by-seller`, payload),
  addSubdivision: (payload: IAddAddressSubdivisionPayload): Promise<IAddress> =>
    axios.post(`${basePath}/subdivision/add`, payload),
  removeSubdivision: (payload: IRemoveAddressSubdivisionPayload): Promise<IAddress> =>
    axios.post(`${basePath}/subdivision/remove`, payload),
  getSuggestions: (params: IAddressSuggestionsParams): Promise<IAddressSuggestionCollection> =>
    axios.get(`${basePath}/suggestions`, { params }),
};
